var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilledCs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 53,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0001 33.3333C8.15913 33.3333 6.66675 34.8257 6.66675 36.6667V56.6667C6.66675 62.1895 11.1439 66.6667 16.6667 66.6667H63.3334C68.8563 66.6667 73.3334 62.1895 73.3334 56.6667V36.6667C73.3334 34.8257 71.841 33.3333 70.0001 33.3333H10.0001ZM16.6667 46.6667C14.8258 46.6667 13.3334 48.159 13.3334 50C13.3334 51.8409 14.8258 53.3333 16.6667 53.3333H36.6667C38.5077 53.3333 40.0001 51.8409 40.0001 50C40.0001 48.159 38.5077 46.6667 36.6667 46.6667H16.6667Z",
    fill: "#6F767E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66675 23.3333C6.66675 17.8105 11.1439 13.3333 16.6667 13.3333H63.3334C68.8563 13.3333 73.3334 17.8105 73.3334 23.3333C73.3334 25.1743 71.841 26.6667 70.0001 26.6667H10.0001C8.15913 26.6667 6.66675 25.1743 6.66675 23.3333Z",
    fill: "#6F767E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledCs);
export default __webpack_public_path__ + "static/media/filledCS.3001e4e576be2803e2015e8017995d5f.svg";
export { ForwardRef as ReactComponent };